import { render, staticRenderFns } from "./TaskImportHighBand.vue?vue&type=template&id=c0a54b7c&scoped=true"
import script from "./TaskImportHighBand.vue?vue&type=script&lang=js"
export * from "./TaskImportHighBand.vue?vue&type=script&lang=js"
import style0 from "./TaskImportHighBand.vue?vue&type=style&index=0&id=c0a54b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a54b7c",
  null
  
)

export default component.exports